module.exports = __webpack_public_path__ + "static/media/arimaxe_logo.a84bee22.png";